module.exports = __webpack_public_path__ + "static/img/SketchPng5eb7835fc957042f4b02048930b15033b02aadc08574d830df2c060761b9879a.96c56ce3.png";